// Financial Dashboard config

import { Cube, Query, TCubeDimension, TCubeMeasure } from "@cubejs-client/core"
import { View } from "./models"

// get query
export const getQueryByView = (
  cubeName: View,
  meta: Cube[],
  selectedSegment: string,
  selectedYearsScenarios: {
    years: string[]
    scenarios: string[]
  },
) => {
  const filteredCube =
    meta?.find((x: { name: string }) => x.name === cubeName) || ({} as Cube)

  const { dimensions: _dimensions, measures: _measures } = filteredCube

  const segmentsOptions =
    meta?.find((x: { name: string }) => x.name === "segments") || ({} as Cube)

  const dimensions = _dimensions?.map((x: TCubeDimension) => x.name)

  const measures = _measures
    ?.filter(
      (measure: TCubeMeasure) =>
        selectedYearsScenarios.years.includes(
          measure.meta?.["grouping_year"],
        ) &&
        selectedYearsScenarios.scenarios.includes(
          measure.meta["grouping_scenario"],
        ),
    )
    .map((x) => x.name)

  const segments = [selectedSegment] || []

  const segmentOptions = segmentsOptions.segments?.map((x) => ({
    value: x.name,
    label: x.meta["title"],
  }))

  const query = { dimensions, measures, segments } as Query
  const extraInfos = { segmentOptions }
  return { query, extraInfos }
}

// get the default view according to url params
export const getDefaultView = (isGcf: string, hasClient: boolean) => {
  if (isGcf === "true") {
    return { key: "gcf", view: "view_hyperion_gcf_data" as View }
  }
  if (isGcf === "false" && hasClient) {
    return { key: "fpna", view: "view_hyperion_fpna_data" as View }
  }
  return { key: "global", view: "view_hyperion_global_data" as View }
}

export type RadioOption = "global" | "gcf" | "fpna"
// read the right cube according to radio selection
export const getSelectedQuery = (queryType: RadioOption) => {
  switch (queryType) {
    case "global":
      return { key: "global", view: "view_hyperion_global_data" as View }

    case "gcf":
      return { key: "gcf", view: "view_hyperion_gcf_data" as View }

    default:
      return { key: "fpna", view: "view_hyperion_fpna_data" as View }
  }
}

export const DEFAULT_CUBE_FD_SEGMENT = "segments._BUD24"

export const GMP_VIEW_TYPE = {
  key: "gcf",
  view: "view_hyperion_gcf_data" as View,
}

const getUrlFilters = (view: View) => {
  if (view === "view_hyperion_global_data") {
    return ["region", "market", "brand"]
  }
  return ["region", "market", "brand", "client"]
}
export const YEAR_SCENARIO_OPTIONS = {
  years: ["2024", "2023", "2022", "2021", "2020"],
  scenarios: ["3RE", "2RE", "1RE", "ACT", "BUD", "FP"],
}

export const getFilterKeys = (
  view: View,
  hasUrlParams: boolean,
  hasParam: (value: string) => boolean,
  isStream: boolean,
) => {
  if (hasUrlParams) {
    if (isStream) {
      return getUrlFilters(view).filter((x) => x !== "brand" && hasParam(x))
    } else {
      return getUrlFilters(view).filter((x) => hasParam(x))
    }
  } else {
    return []
  }
}

export const getFilterKey = (enabledFilter: string, brandParam: string) => {
  if (
    enabledFilter === "brand" &&
    (brandParam === "Kinesso" || brandParam === "Mediabrands")
  ) {
    return "agency"
  }

  if (enabledFilter === "client") {
    return "clientParentCode"
  }

  return enabledFilter
}

export const getFilterValue = (
  key: string,
  hasParam: (value: string) => boolean,
  getParam: (value: string) => void,
) => {
  return hasParam(key) ? getParam(key) : ""
}

// options for radio buttons
export const viewOptions = [
  { value: "global", label: "Global" },
  { value: "fpna", label: "FP&A" },
  { value: "gcf", label: "GCF" },
]
